import React, { useState } from 'react';
import { FileText, Eye, Download, ExternalLink } from 'lucide-react';
import PdfModal from './PdfModal';

const PdfResourceCard = ({ 
  title, 
  description, 
  pdfUrl, 
  tag = "PDF dokument", 
  highlight = false,
  badgeText = null
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div 
        className={`relative flex flex-col justify-between p-6 sm:p-7 rounded-2xl border transition-all duration-300 ${
          highlight 
            ? 'bg-gradient-to-br from-emerald-950 via-emerald-900 to-emerald-950 text-white border-emerald-700 shadow-xl ring-2 ring-emerald-500/30' 
            : 'bg-white hover:bg-zinc-50/80 text-zinc-900 border-zinc-200 hover:border-emerald-300 shadow-sm hover:shadow-lg'
        }`}
      >
        {badgeText && (
          <div className="absolute -top-3 right-6 bg-emerald-500 text-emerald-950 text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full shadow-md">
            {badgeText}
          </div>
        )}

        <div>
          <div className="flex items-center justify-between gap-3 mb-4">
            <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold ${
              highlight 
                ? 'bg-emerald-800/80 text-emerald-200 border border-emerald-700/50' 
                : 'bg-emerald-50 text-emerald-900 border border-emerald-200'
            }`}>
              <FileText className="w-3.5 h-3.5" />
              {tag}
            </span>
          </div>

          <h3 className={`text-xl sm:text-2xl font-bold mb-2.5 leading-snug ${
            highlight ? 'text-white' : 'text-zinc-900'
          }`}>
            {title}
          </h3>

          {description && (
            <p className={`text-sm sm:text-base leading-relaxed mb-6 ${
              highlight ? 'text-emerald-100/90' : 'text-slate-600'
            }`}>
              {description}
            </p>
          )}
        </div>

        <div className="pt-4 border-t border-zinc-200/20 flex flex-wrap items-center gap-2.5 sm:gap-3">
          <button
            type="button"
            onClick={() => setIsModalOpen(true)}
            className={`inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl font-bold text-sm transition-all shadow-sm ${
              highlight
                ? 'bg-white text-emerald-950 hover:bg-emerald-100'
                : 'bg-emerald-900 text-white hover:bg-emerald-800'
            }`}
          >
            <Eye className="w-4 h-4" />
            Vis PDF
          </button>

          <a
            href={pdfUrl}
            download
            className={`inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl font-semibold text-sm transition-all border ${
              highlight
                ? 'bg-emerald-900/60 hover:bg-emerald-800 text-white border-emerald-700'
                : 'bg-white hover:bg-zinc-100 text-zinc-800 border-zinc-300'
            }`}
          >
            <Download className="w-4 h-4" />
            Download
          </a>

          <a
            href={pdfUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={`inline-flex items-center justify-center p-2.5 rounded-xl text-xs font-medium transition-colors ${
              highlight
                ? 'text-emerald-300 hover:text-white hover:bg-emerald-800/60'
                : 'text-zinc-500 hover:text-emerald-900 hover:bg-zinc-100'
            }`}
            title="Åbn i nyt faneblad"
          >
            <ExternalLink className="w-4 h-4" />
          </a>
        </div>
      </div>

      <PdfModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        pdfUrl={pdfUrl}
        title={title}
        description={description}
      />
    </>
  );
};

export default PdfResourceCard;
